/**
 * Serviço com métodos utilitários para traduzir conteúdo.
 * Tem a ideia apenas de centralizar a referência ao i18n e facilitar a tradução em serviços.
 */
import i18nWrapper from '@/i18n/i18n';

/**
 * Utilitário de tradução para números, aplicando a formatação de acordo com a cultura.
 * @param {Number|String} number Valor numérico a ser formatado.
 * @param {...any} [options] Opções de tradução suportadas pelo vue-i18n que serão repassadas na
 *   chamada do método "n".
 */
export function formatNumber(number, ...options) {
  if (number === undefined || number === null) {
    return number;
  }
  const validNumber = typeof number !== 'number' ? parseFloat(number) : number;
  return i18nWrapper.i18n.n(validNumber, ...options);
}

/**
 * Utilitário de tradução.
 * @param {String} path Caminho de tradução na estrutura do i18n.
 * @param {Object} [options] Opções de tradução suportadas pelo vue-i18n.
 */
export default function translate(path, options) {
  return i18nWrapper.i18n.t(path, options);
}
